import React, { useEffect, useRef } from 'react'
import { TYPE_META } from './fieldTypes'
import { useT } from './translations'

export const TypeIcon = ({ type, small }) => {
  const meta = TYPE_META[type] || TYPE_META.text
  return (
    <span className={`fb-type-icon tone-${meta.tone}${small ? ' is-small' : ''}`}>
      <i className={`fas ${meta.icon}`} />
    </span>
  )
}

const GROUPS = [
  ['text', 'description', 'static'],
  ['number', 'float', 'date', 'date_time'],
  ['yes_no', 'checkbox', 'select', 'select_prefill'],
  ['table', 'e_sign', 'photos', 'page_break']
]

const TypePicker = ({ value, onPick, onClose, exclude = [], extra }) => {
  const t   = useT()
  const ref = useRef(null)

  useEffect(() => {
    const close = (event) => { if (ref.current && !ref.current.contains(event.target)) { onClose() } }
    const escape = (event) => { if (event.key === 'Escape') { onClose() } }
    document.addEventListener('mousedown', close)
    document.addEventListener('keydown', escape)
    return () => {
      document.removeEventListener('mousedown', close)
      document.removeEventListener('keydown', escape)
    }
  }, [onClose])

  return (
    <div className="fb-popover fb-type-picker" ref={ref}>
      {GROUPS.map((group, index) => (
        <div className="fb-type-group" key={index}>
          {group.filter((type) => !exclude.includes(type)).map((type) => (
            <button
              key={type}
              type="button"
              className={`fb-type-option${value === type ? ' active' : ''}`}
              onClick={() => onPick(type)}
            >
              <TypeIcon type={type} />
              <span>{t.types[type]}</span>
            </button>
          ))}
        </div>
      ))}
      {extra}
    </div>
  )
}

export default TypePicker
